export default {
	title: 'Strategic plan',
	tabs: {
		general: {
			title: 'General'
		},
		filters: {
			title: 'View filters'
		},
		bot: {
			title: 'AI'
		},
		export: {
			title: 'Export'
		},
		display: {
			title: 'Display'
		}
	},
	filters: {
		responsible: {
			title: 'Filter by responsible',
			placeholder: 'Responsible name'
		},
		completion: {
			title: 'Completion filter',
			not_started: 'Not started',
			in_progress: 'In progress',
			completed: 'Completed'
		},
		dates: {
			title: 'Dates filter'
		},
		startOn: {
			title: 'Start date filter',
			undefined: 'No date',
			past: 'Past',
			ending_week: 'Starting in a week',
			ending_month: 'Starting in a month',
			ending_quarter: 'Starting in a quarter',
			ending_year: 'Starting in a year'
		},
		endOn: {
			title: 'End date filter',
			undefined: 'No date',
			done: 'Done',
			overdue: 'Overdue',
			ending_week: 'Ending in a week',
			ending_month: 'Ending in a month',
			ending_quarter: 'Ending in a quarter',
			ending_year: 'Ending in a year'
		}
	},

	display: {
		sort: {
			title: 'Branch sorting',
			startOn: 'By start date',
			name: 'By name',
			manual: 'Manual order'
		}
	},
	all_icons: 'Icons filter',
	no_icon: 'No icon',
	onboarding: {
		title: 'Action plan review',
		description:
			'Check that the axes and items match your reading of the plan.'
	}
};
